<template>
    <div class="recharge">
        <p class="font28" style="color: #333333">充值金额</p>
        <div class="recharge-money flex align-center">
            <span class="recharge-money-icon">¥</span>
            <van-field
                maxlength="5"
                v-model="money"
                disabled
                type="digit"
                clearable
            ></van-field>
        </div>
        <van-row class="recharge-money-list" gutter="10">
            <van-col
                span="6"
                v-for="(item, index) in rechargeList"
                :key="index"
                @click="pickMoney(item, index)"
            >
                <div
                    :class="[
                        'recharge-money-item',
                        active == index
                            ? 'recharge-money-itemA'
                            : 'recharge-money-itemD',
                    ]"
                >
                    {{
                        (
                            Number(item.cashMoney) - Number(item.giveMoney)
                        ).toFixed(0)
                    }}元
                    <img
                        v-if="item.giveMoney"
                        src="@/assets/images/惠.png"
                        alt=""
                    />
                </div>
                <div v-if="item.remark" class="remark">{{ item.remark }}</div>
            </van-col>
        </van-row>

        <div class="quickPay-tip flex align-center">
            <img src="@/assets/images/pay/pay-tip.png" alt="" />
            <p>
                温馨提示：充值费用仅限用于停车泊位费缴纳，不能用于购买月卡服务，充值成功后不可退款。
            </p>
        </div>
        <senselessPayment style="margin-top: 40px" />
        <!-- <div style="font-size: 16px; color: red" v-if="couponItem.cashMoney">满{{ couponItem.cashMoney }}元减{{ couponItem.giveMoney }}元</div> -->
        <div class="recharge-confirm">
            <van-button :loading="loading" class="comfirm-btn" @click="recharge"
                >立即充值</van-button
            >
            <van-button
                :loading="loading"
                class="comfirm-btn"
                @click="goOtherPay"
                >他人代充</van-button
            >
        </div>
        <DialogWarn
            :show.sync="showDialogWarn"
            :isNeedCancelBtn="false"
            @handleConfirm="goPaymentOrder"
            rightBtnText="前往"
            :content="content"
        />
        <qrCodeDialog :show.sync="showQrCodeDialog" :content="qrCodeContent" />
    </div>
</template>

<script>
import {
    submitParkingOrderFromApp,
    queryCashConfig,
    whetherPayment,
    updateUserWalletNofeelPay,
} from "@/api/api";
import { throttleBytimestamp, obj2Param } from "@/libs/tools";
import { calcPayChannel } from "@/libs/env";
import senselessPayment from "@/components/senselessPayment";
import { mapGetters } from "vuex";
import DialogWarn from "@/components/base/dialog/dialogWarn.vue";
import qrCodeDialog from "@/components/base/dialog/qrCodeDialog.vue";
import { insertPaymentOnBehalfValidCode } from "@/api/apiNoAuth";
export default {
    name: "Recharge",
    components: { senselessPayment, DialogWarn, qrCodeDialog },
    data() {
        return {
            money: 20,
            showMoney: 0,
            active: 0,
            rechargeList: [
                {
                    cashMoney: 20, // 金额
                    giveMoney: 0, // 优惠金额
                    id: 1,
                },
                {
                    cashMoney: 50,
                    giveMoney: 0,
                    id: 2,
                },
                {
                    cashMoney: 100,
                    giveMoney: 0,
                    id: 3,
                },
                {
                    cashMoney: 200,
                    giveMoney: 0,
                    id: 4,
                },
                {
                    cashMoney: 300,
                    giveMoney: 0,
                    id: 5,
                },
                {
                    cashMoney: 500,
                    giveMoney: 0,
                    id: 6,
                },
                {
                    cashMoney: 1000,
                    giveMoney: 0,
                    id: 7,
                },
                {
                    cashMoney: 2000,
                    giveMoney: 0,
                    id: 8,
                },
            ],
            loading: false,
            isFullMinus: false, // 是否满减
            couponMoney: 0,
            couponItem: {}, // 优惠配置
            showDialogWarn: false,
            content: "尊敬的车主，您的车辆当前存在订单未缴清，请前往缴费。",
            showQrCodeDialog: false,
            qrCodeContent: "",
        };
    },

    computed: {
        ...mapGetters({ appEnv: "getAppEnv" }),
    },
    mounted() {
        queryCashConfig({ type: 1 }).then((res) => {
            if (res.data) {
                this.isFullMinus = true;
                this.rechargeList = res.data.reduceInfo;
                this.money =
                    this.rechargeList[0].cashMoney -
                    this.rechargeList[0].giveMoney;
                this.couponMoney = this.rechargeList[0].giveMoney;
            }
        });
    },
    watch: {
        money: {
            handler(newValue, oldValue) {
                // this.couponMoney = 0;
                // this.couponItem = {};
                // if (!this.isFullMinus) return;
                // let item = {
                //     cashMoney: 0,
                // };
                // //根据优惠规则计算优惠金额
                // for (let i of this.rechargeList) {
                //     if (i.cashMoney <= newValue && i.cashMoney >= item.cashMoney && i.giveMoney) {
                //         item = i;
                //     }
                // }
                // console.log(item);
                // this.couponMoney = item.giveMoney ? item.giveMoney : 0;
                // this.couponItem = item;
            },
        },
    },
    methods: {
        pickMoney(item, index) {
            this.money = item.cashMoney - item.giveMoney;
            this.couponMoney = item.giveMoney;
            this.active = index;
        },
        // 充值
        recharge: throttleBytimestamp(function () {
            whetherPayment().then((res) => {
                if (res.data.openMode === 1) {
                    if (res.data.status === 0) {
                        this.showDialogWarn = true;
                    } else if (res.data.status === 1) {
                        this.rechargeFun();
                    }
                } else {
                    this.rechargeFun();
                }
            });
        }, 2000),

        rechargeFun() {
            if (!this.money || this.money == 0) {
                this.$toast("充值金额必须大于0");
                return;
            }
            if (this.money > 10000) {
                this.$toast("充值金额最高为1万元");
                return;
            }

            let money = Number(this.money);
            money = (money > 0 ? money : 0).toFixed(2);
            let obj = {
                business: "walletup",
                parkType: 1,

                certId: localStorage.getItem("openId"),
                orderInfo: [
                    {
                        buyer: localStorage.getItem("userId"),
                        couponMoney: this.couponMoney,
                        couponRandomMoney: 0,
                        couponTicketMoney: 0,
                        goodDetail: "余额充值",
                        goodSubject: "余额充值",
                        orderMoney:
                            Number(this.money) + Number(this.couponMoney),
                        payForMoney: 0,
                        realMoney: this.money,

                        scanDiscount: 0,
                        scanDiscountConfigId: null,
                    },
                ],
                payChannel: calcPayChannel(this.appEnv, 2),
                totalRealMoney: money,
            };
            this.loading = true;

            submitParkingOrderFromApp(obj)
                .then((res) => {
                    if (this.appEnv.appEnv == "miniprogram") {
                        this.miniprogramHandle(res);
                    } else {
                        window.location.href = res.data.payUrl;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        goPaymentOrder() {
            if (localStorage.getItem("userId")) {
                let obj = {
                    token: localStorage.getItem("token"),
                    userId: localStorage.getItem("userId"),
                    xcxOpenId: localStorage.getItem("openId"),
                    plateNum: localStorage.getItem("openId"),
                    // toAllPay: true //不展示单笔支付，直接一键全部支付，否则不需要该携参
                };
                let str = `${
                    process.env.VUE_APP_BASE_API
                }qginsideparking/page/plateNumBill?${obj2Param(obj)}`;
                if (this.appEnv.appEnv == "miniprogram") {
                    wx.miniProgram.navigateTo({
                        url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(
                            str
                        )}`,
                    });
                } else {
                    window.location.href = str;
                }
            }
        },

        miniprogramHandle(res) {
            let signParam = res.data.signParam;
            let obj = {
                realMoney: this.money,
                timeStamp: signParam.timeStamp,
                nonceStr: signParam.nonceStr,
                package: encodeURIComponent(signParam.package),
                sign: encodeURIComponent(signParam.sign),
                signType: signParam.signType,
            };
            let str = obj2Param(obj);
            wx.miniProgram.navigateTo({
                url: `/pages/tab2/pay/pay?${str}`,
            });
        },
        goOtherPay() {
            whetherPayment().then((res) => {
                if (res.data.openMode === 1) {
                    if (res.data.status === 0) {
                        this.showDialogWarn = true;
                    } else if (res.data.status === 1) {
                        this.showQrCode();
                    }
                } else {
                    this.showQrCode();
                }
            });
        },

        async showQrCode() {
            if (localStorage.getItem("userId")) {
                let obj = {
                    userId: localStorage.getItem("userId"),
                    openId: localStorage.getItem("openId"),
                    money: this.money,
                    couponMoney: this.couponMoney,
                    validCode: this.createCode(),
                };
                let { data } = await insertPaymentOnBehalfValidCode({
                    validCode: obj.validCode,
                });
                if (data == 1) {
                    this.qrCodeContent = `${
                        process.env.VUE_APP_REDIRECT_URI
                    }?path=payByOthers&${obj2Param(obj)}`.replace(/&/g, "%26");
                    console.log(this.qrCodeContent);
                    this.showQrCodeDialog = true;
                }
            }
        },

        createCode() {
            const len = 6;
            let code = "";
            var possible = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
            for (var i = 0; i < len; i++) {
                code += possible.charAt(
                    Math.floor(Math.random() * possible.length)
                );
            }
            return code;
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";
.quickPay-tip {
    margin-top: 70px;

    img {
        width: 24px;
        height: 24px;
    }

    p {
        font-size: 26px;
        color: #616161;
        margin-left: 8px;
    }
}
.remark {
    text-align: center;
    color: #616161;
    margin-top: -20px;
}
.recharge {
    min-height: 100vh;
    background: #fff;
    padding: 24px;

    .recharge-money {
        // padding: 12px 0;
        margin-top: 24px;
        border-bottom: 1px solid #dbdada;

        .recharge-money-icon {
            font-size: 104px;
        }
    }

    .recharge-money-list {
        margin-top: 44px;

        .recharge-money-item {
            width: 165.5px;
            height: 73px;
            text-align: center;
            line-height: 73px;
            margin-bottom: 27px;
            color: #616161;
            font-size: 34px;
            border-radius: 5px;
            position: relative;
        }
        img {
            width: 35px;
            height: 29px;
            position: absolute;
            // top: -20px;
            right: -10px;
            // margin-top: -100px;
            // margin-left: -100px;
        }

        .recharge-money-itemA {
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            color: #fff;
        }

        .recharge-money-itemD {
            border: 1px solid #bfbfbf;
            color: #616161;
        }
    }
    .comfirm-btn {
        width: 45%;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    }
    .recharge-confirm {
        margin-top: 60px;
        display: flex;
        justify-content: space-around;
    }
}
</style>
<style lang="less" scoped>
/deep/ .van-field__control:disabled {
    color: #323233;
    font-size: 32px;
    -webkit-text-fill-color: #323233;
}
.recharge-money {
    .van-field__control {
        caret-color: #009af3;
        font-size: 32px;
    }
}
</style>
